import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ResourceWerxConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ResourceWerxApiModule {
    public static forRoot(configurationFactory: () => ResourceWerxConfiguration): ModuleWithProviders<ResourceWerxApiModule> {
        return {
            ngModule: ResourceWerxApiModule,
            providers: [ { provide: ResourceWerxConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ResourceWerxApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ResourceWerxApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
